<template>
  <div class="file-manager-container file-manager-list container-fuild mt-5">
    <div class="row">
      <div class="col-12 mb-4 row item-row">
        <div class="col-1 folder-icon"></div>
        <div class="col-7 row px-0 details">
          <div class="file-item-name col-12">{{ $t("COMMON.NAME") }}</div>
        </div>
        <div class="col-2 details-right">
          <span class="updated-at"> {{ $t("COMMON.UPDATED_AT") }} </span>
        </div>
        <div class="col-2 details-right">
          <span class="updated-at"> {{ $t("COMMON.CREATED_AT") }} </span>
        </div>
      </div>

      <div class="col-12 mb-1 row" v-if="folder.id">
        <div class="col-1">
          <div
            class="file-item file-item-folder"
            @dblclick="navigateToParent()"
          >
            <div class="file-item-content">
              <div class="file-item-icon">
                <i class="fa fa-reply"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="col-11"></div>
      </div>

      <div
        v-for="folder in folder.subfolders"
        :key="`folder-${folder.id}`"
        class="col-12 mb-1 row item-row"
      >
        <div class="col-1 folder-icon">
          <div
            class="file-item file-item-folder"
            :class="[
              {
                selected: selectedItems.some(
                  (item) => item.id === folder.id && item.type == 'folders'
                ),
                locked: folder.locked,
              },
            ]"
            @dblclick="navigateToFolder(folder.id)"
            @click="selectItem(folder)"
          >
            <div class="file-item-content">
              <div class="file-item-icon">
                <i class="fa fa-folder"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="col-7 row px-0 details">
          <div class="file-item-name col-12">
            {{ folder.name }}
          </div>
          <div
            v-if="query && folder.full_path"
            class="file-item-path col-12 text-muted"
          >
            {{ folder.full_path }}
          </div>
          <!-- <div
            v-if="
              $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS) &&
              folder.organization
            "
            class="file-item-organization col-12"
          >
            <span class="btn btn-sm btn-info">
              <i class="ni ni-building"></i>
              {{ folder.organization.name }}
            </span>
          </div> -->
        </div>
        <div class="col-2 details-right">
          <span class="updated-at">
            {{ $timeZoneDateFormat(folder.updated_at) }}
          </span>
        </div>
        <div class="col-2 details-right">
          <span class="updated-at">
            {{ $timeZoneDateFormat(folder.created_at) }}
          </span>
        </div>
      </div>
      <div
        v-for="file in folder.files"
        :key="`file-${file.id}`"
        class="col-12 mb-1 row item-row"
      >
        <div class="col-1 file-icon">
          <div
            class="file-item file-item-folder"
            :class="[
              {
                selected: selectedItems.some(
                  (item) => item.id === file.id && item.type == 'files'
                ),
              },
            ]"
            @dblclick="viewFile(file)"
            @click="selectItem(file)"
          >
            <div class="file-item-content">
              <div class="file-item-icon">
                <i class="fa fa-file"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="col-7 row px-0 details">
          <div class="file-item-name col-12">
            {{ file.name }}
          </div>
          <div
            v-if="query && (filePath(file) || canOpenFileLocation(file))"
            class="file-item-path col-12 text-muted"
          >
            <span v-if="filePath(file)">{{ filePath(file) }}</span>
            <button
              v-if="canOpenFileLocation(file)"
              type="button"
              class="btn btn-link btn-sm py-0 px-1"
              @click.stop.prevent="openFileLocation(file)"
            >
              {{ $t("FILES.OPEN_LOCATION") }}
            </button>
          </div>
          <!-- <div
            v-if="
              $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS) &&
              folder.organization
            "
            class="file-item-organization col-12"
          >
            <span class="btn btn-sm btn-info">
              <i class="ni ni-building"></i>
              {{ file.organization.name }}
            </span>
          </div> -->
        </div>
        <div class="col-2 details-right">
          <span class="updated-at">
            {{ $timeZoneDateFormat(file.updated_at) }}
          </span>
        </div>
        <div class="col-2 details-right">
          <span class="updated-at">
            {{ $timeZoneDateFormat(file.created_at) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { buildFileUrl } from "@/helpers/fileUrl";

export default {
  components: {},

  mixins: [],

  props: {
    folder: {
      type: Object,
      default: null,
      description: "Current folder",
    },
    query: {
      type: String,
      default: null,
    },
  },

  computed: {},

  watch: {},

  data() {
    return {
      selectedItems: [],
    };
  },

  methods: {
    navigateToFolder(id) {
      this.selectedItems = [];
      this.$emit("onNavigateTo", id);
    },
    navigateToParent() {
      if (this.folder.parent) {
        this.navigateToFolder(this.folder.parent.id);
      } else {
        this.navigateToFolder(null);
      }
    },

    selectItem(selectedItem) {
      if (this.selectedItems.some((item) => item.id === selectedItem.id)) {
        this.selectedItems = this.selectedItems.filter(
          (item) =>
            item.id !== selectedItem.id && item.type !== selectedItem.type
        );
      } else {
        this.selectedItems.push(selectedItem);
      }
      this.$emit("onSelectItems", this.selectedItems);
    },

    viewFile(file) {
      window.open(this.fileUrl(file), "_blank");
    },

    fileUrl(file, options = {}) {
      return buildFileUrl(file?.url, file?.name, options);
    },

    filePath(file) {
      if (!file) {
        return null;
      }
      const folderInfo = this.fileFolderInfo(file);
      const folderFullPath = folderInfo.fullPath || "";
      const trimmedFolderPath =
        folderFullPath && folderFullPath !== "/"
          ? folderFullPath.replace(/\/$/, "")
          : "";
      const fileName = file.name || file.file_name || "";
      if (!trimmedFolderPath && !fileName) {
        return null;
      }
      if (!fileName) {
        return trimmedFolderPath || "/";
      }
      if (!trimmedFolderPath) {
        return `/${fileName}`;
      }
      return `${trimmedFolderPath}/${fileName}`;
    },

    fileFolderInfo(file) {
      const folderRelation =
        file.folder ||
        file.folderData ||
        file.relationships?.folder?.data ||
        file.relationships?.folder ||
        null;
      const fullPath =
        file.folder_full_path ||
        folderRelation?.full_path ||
        folderRelation?.fullPath ||
        folderRelation?.data?.full_path ||
        folderRelation?.data?.fullPath ||
        "";
      const id =
        folderRelation?.id ||
        folderRelation?.data?.id ||
        file.folder_id ||
        file.folderId ||
        null;

      return {
        id,
        fullPath,
      };
    },

    canOpenFileLocation(file) {
      if (!file) {
        return false;
      }
      const folderId = this.fileFolderInfo(file).id;
      return folderId !== null && folderId !== undefined;
    },

    openFileLocation(file) {
      const folderId = this.fileFolderInfo(file).id;
      if (folderId === null || folderId === undefined) {
        return;
      }
      this.selectedItems = [];
      this.$emit("onSelectItems", this.selectedItems);
      this.$emit("onNavigateTo", folderId);
    },
  },
};
</script>

<style lang="sass">
.file-manager-list
  .item-row
    .details, .details-right
      border-bottom: 1px solid var(--gray)

  .details-right
    display: flex
    align-items: center
    flex-direction: row-reverse

  .file-item-name
    font-size: 1.2rem
    font-weight: 900
    display: flex
    align-items: center
  .file-item-path
    font-size: 0.85rem
    color: #525f7f
    word-break: break-all
    margin-top: -0.25rem
    display: flex
    align-items: center
    gap: 0.35rem
    flex-wrap: wrap

  .file-item
    position: relative
    padding-bottom: 100%
    background-color: var(--gray)
    border-radius: 5px
    text-align: center
    color: #000
    cursor: pointer

    .file-item-organization
      height: 100%
      width: 100%
      position: absolute
      display: flex
      flex-direction: column-reverse
      flex-wrap: nowrap
      align-items: stretch
      justify-content: flex-start

    &.selected
      box-shadow: 0px 0px 10px var(--primary)
      &:before
        content: "\f14a"
        font-family: "Font Awesome 5 Free"
        font-size: 24px
        font-weight: 900
        color: var(--primary)
        position: absolute
        top: 5px
        left: 5px
        transform: translate(-50%, -50%)

    &.locked
      &:not(.selected)
        box-shadow: 0px 0px 2px var(--info)
      &:after
        content: "\f023"
        font-family: "Font Awesome 5 Free"
        font-size: 25px
        font-weight: 900
        color: var(--info)
        position: absolute
        top: 5px
        right: -15px
        transform: translate(-50%, -50%)

    &-content
      position: absolute
      top: 50%
      transform: translateY(-50%)
      left: 0
      width: 100%
      height: 100%
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      font-size: 2rem
      user-select: none

      .file-item-icon
        line-height: 0
      .file-item-name
        font-size: 1rem
        line-height: 1rem
        text-overflow: ellipsis
        overflow: hidden
        width: 100%
        padding: 5px
        display: -webkit-box
        -webkit-box-orient: vertical
        -webkit-line-clamp: 2
        height: 3rem
</style>
